import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  ChangeDetectorRef,
  SimpleChanges,
  HostBinding,
  Output,
  EventEmitter,
} from '@angular/core';
import { QRService } from './qr.service';
import { AdQRConfig } from './qr.config';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'qr',
  template: `
  <img src="{{dataURL}}">
  `,
  preserveWhitespaces: false,
  // tslint:disable-next-line:use-host-property-decorator
  host: { '[class.ad-qr]': 'true' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QRComponent implements OnChanges {
  dataURL: string;
  // region: fields

  /** èæ¯ */
  @Input() background: string;
  /** èæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ */
  @Input() backgroundAlpha: number;
  /** åæ¯ */
  @Input() foreground: string;
  /** åæ¯éæçº§å«ï¼èå´ï¼`0-1` ä¹é´ */
  @Input() foregroundAlpha: number;
  /** è¯¯å·®æ ¡æ­£çº§å« */
  @Input() level: string;
  /** äºç»´ç è¾åºå¾çMIMEç±»å */
  @Input() mime: string;
  /** åè¾¹è·ï¼åä½ï¼pxï¼ */
  @Input() padding: number;
  /** å¤§å°ï¼åä½ï¼pxï¼ */
  @HostBinding('style.height.px')
  @HostBinding('style.width.px')
  @Input() size: number;
  /** å¼ */
  @Input() value: string;
  /** åæ´æ¶åè° */
  @Output() change = new EventEmitter<string>();

  // endregion

  constructor(
    cog: AdQRConfig,
    private srv: QRService,
    private cd: ChangeDetectorRef,
  ) {
    Object.assign(this, cog);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dataURL = this.srv.refresh({
      background: this.background,
      backgroundAlpha: this.backgroundAlpha,
      foreground: this.foreground,
      foregroundAlpha: this.foregroundAlpha,
      level: this.level,
      mime: this.mime,
      padding: this.padding,
      size: this.size,
      value: this.value
    });
    this.cd.detectChanges();
    this.change.emit(this.dataURL);
  }
}
